/* eslint-disable prettier/prettier */
import { isMobileBrowser, isWebview, isDesktopBrowser } from '../helper';

//Default guideline sizes are based on standard ~5" screen mobile device
const guidelineBaseWidth = 350;
const guidelineBaseHeight = 680;

const getDimensions = () => {
  const width = isDesktopBrowser ? 550 : window.innerWidth;
  const height = window.innerHeight;

  const [shortDimension, longDimension] = width < height ? [width, height] : [height, width];
  return { shortDimension, longDimension };
};

export const scale = (size: number) => {
  const { shortDimension } = getDimensions();
  return (shortDimension / guidelineBaseWidth) * size;
};

export const verticalScale = (size: number) => {
  const { longDimension } = getDimensions();
  return (longDimension / guidelineBaseHeight) * size;
};

export const moderateScale = (size: number, factor = 0.5) => size + (scale(size) - size) * factor;
export const moderateVerticalScale = (size: number, factor = 0.5) =>
  size + (verticalScale(size) - size) * factor;

export const s = scale;
export const vs = verticalScale;
export const ms = moderateScale;
export const mvs = moderateVerticalScale;

export const resizeFontSize = () => {
  const root = document.documentElement;
  root.style.setProperty('--global-font', ms(12).toFixed(1) + 'px');
};

if (isMobileBrowser && !isWebview) {
  resizeFontSize();
} else if (isWebview) {
  window.addEventListener('resize', () => {
    if (window.innerWidth !== 0 && window.innerHeight !== 0) {
      resizeFontSize();
    }
  });
}
